import React from 'react';
import { IconButton } from '@noths/polaris-design-system-core-components';

import { PRODUCT_MEDIA_TABPANEL_CONTAINER_ID } from 'src/components/organisms/ProductMediaCarousel/constants/elementIds';
import * as styles from './ImageNavigationButtons.styles';

interface ImageNavigationButtonProps {
  controls?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/* The wrapper carries the positioning so the IconButton is left to be an IconButton. A consumer
   deciding where a design system component sits is fine; a consumer restyling one is not, and
   passing it a css prop of our own would be the latter. */
export const PreviousButton = ({
  controls = PRODUCT_MEDIA_TABPANEL_CONTAINER_ID,
  onClick,
}: ImageNavigationButtonProps) => {
  return (
    <div css={[styles.navigationButton, styles.prevNavigationButton]}>
      <IconButton
        aria-controls={controls}
        aria-label="Show previous image"
        icon="actionBack"
        onClick={onClick}
      />
    </div>
  );
};

export const NextButton = ({
  controls = PRODUCT_MEDIA_TABPANEL_CONTAINER_ID,
  onClick,
}: ImageNavigationButtonProps) => {
  return (
    <div css={[styles.navigationButton, styles.nextNavigationButton]}>
      <IconButton
        aria-controls={controls}
        aria-label="Show next image"
        icon="actionForward"
        onClick={onClick}
      />
    </div>
  );
};
